define("settings/controllers/groups/index", ["exports", "@ember/controller", "@ember/service", "@glimmer/tracking"], function (_exports, _controller, _service, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  0; //eaimeta@70e063a35619d71f0,"@ember/controller",0,"@ember/service",0,"@glimmer/tracking"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let GroupsIndexController = _exports.default = (_class = class GroupsIndexController extends _controller.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor2, this);
      _initializerDefineProperty(this, "settings", _descriptor3, this);
      _initializerDefineProperty(this, "plans", _descriptor4, this);
      _initializerDefineProperty(this, "showSourcelessTrialConfirmationModal", _descriptor5, this);
    }
    get sortedGroups() {
      return this.groups.sortBy('name');
    }
    get isMobileSubscription() {
      return this.subscriptions.isMobileSubscription;
    }
    get numUsedSocialSets() {
      return this.auth.currentAccount.socialIdentitiesCount || 0;
    }
    get groups() {
      return this.model;
    }
    get socialSetsRemaining() {
      const remaining = (this.totalSocialSets || 1) - this.numUsedSocialSets;
      return Math.max(remaining, 0);
    }
    get totalSocialSets() {
      return this.auth.currentAccount.totalSocialSets || 1;
    }
    get canCreateNewGroup() {
      return Boolean(this.settings.canCreateNewGroup);
    }
    get firstGroup() {
      return this.sortedGroups[0];
    }
    get isAccountOwner() {
      return this.settings.isAccountOwner;
    }
    get isSourcelessTrialABTest() {
      return this.auth.currentAccount?.rolloutSourcelessTrial;
    }
    get shouldShowSourcelessTrialConfirmation() {
      return this.auth.currentAccount?.canTrialPlan && this.isSourcelessTrialABTest;
    }
    get rolloutMetaMarketingApi() {
      const isDev = this.auth.currentUserModel?.dev ?? false;
      return isDev && (this.auth.currentAccount?.rolloutMetaMarketingApi ?? false);
    }
    get getGrowthPlan() {
      return this.plans.getPlan('growth');
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "settings", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "plans", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "showSourcelessTrialConfirmationModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  })), _class);
});